import _ from "lodash";
import { prettyName } from "@/helpers/user";
import { searchTypeMap } from "./search";

export default function makeCompactSearchesTableData({ searches, currentOwner }) {
  return searches
    ?.filter((s) => {
      return _.get(s, ["type"]);
    })
    .map((search) => {
      if (!search) return null;

      const { assignedUsers, id, owner, title, status, clientCorporation, submissions } = search;

      const callTime = search?.notes?.reduce(
        (acc, { minutesSpent = 0 }) => (Number.isInteger(minutesSpent) ? minutesSpent + acc : acc),
        0
      );

      return {
        id,
        search: `${title} (${id})`,
        clientCorporationName: clientCorporation?.name,
        status,
        priority: (_.get(search, ["type"]) && searchTypeMap[_.get(search, ["type"])]) || "Unknown",
        submissions,
        callTime,
        accountManager: prettyName(owner),
        team: _.uniqBy([..._.sortBy(assignedUsers.data, "id")], "id").map((u) => {
          u.active = currentOwner ? currentOwner.id === u.id : true;

          return u;
        })
      };
    });
}
